import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0222 from "../../../lesson/course-02/lesson-22/lesson";
import lesson0223 from "../../../lesson/course-02/lesson-23/lesson";
import lesson0224 from "../../../lesson/course-02/lesson-24/lesson";
import lesson0225 from "../../../lesson/course-02/lesson-25/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "4763aa5d-902b-4454-9aef-c37b5208a101",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0222),
    lesson: lesson0222,
  },
  {
    id: "49db1578-2ad7-431b-bc42-911e97b43c64",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0223),
    lesson: lesson0223,
  },
  {
    id: "17bbfa20-7c12-471b-9614-1353318a0227",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0224),
    lesson: lesson0224,
  },
  {
    id: "f3c7623c-715a-4d70-b7e7-28d3cd64d95e",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0225),
    lesson: lesson0225,
  },
];

export default lessonLinks;
